 .c-guide {
  margin-top: 5em;
  margin-bottom: 5em;
  padding: 0 0.75em;
} @media print { .c-guide {
    margin-top: 0px;
    margin-bottom: 0px;
  }
} @media (max-width: 767px) { .c-guide {
    margin-top: 0px;
    margin-bottom: 5rem;
  }
}

   .c-guide__toc {
    padding-right: 1.5em;
    padding-top: 0.25em;
    position: sticky;
    top: 100px;
    float: left;
    width: 30%;
    min-height: 200px;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

   .c-guide__toc-link {
    color: #52525b;
    font-weight: 500;
    border-left: 4px solid #d4d4d8;
    padding: 3px 15px;
    display: flex;
    margin-bottom: 5px;
  }

   .c-guide__toc-link:hover {
      color: #1d4ed8;
    }

   .c-guide__toc-link:active,
    .c-guide__toc-link:focus,
    .c-guide__toc-link:visited {
      color: #52525b;
    }

   .c-guide__toc-link--current {
      color: #2563eb !important;
      border-color: #2563eb;
    }

   .c-guide h2 {
    margin-top: -22px;
    padding-top: 34px;
  }

   .c-guide h2:not(:first-of-type) {
      border-top: 1px solid #f4f4f5;
      padding-top: 30px;
      margin-top: 30px;
    }

   .c-guide .prose {
    float: right;
    width: 70%;
    max-width: initial;
  }

   .c-guide .prose h2:first-child {
      margin-top: -32px;
    }

   @media (max-width: 767px) { .c-guide .prose {
    width: 100%;
  }
}

   @media print { .c-guide .prose {
    width: 100%;
  }
}

   .c-guide .c-mini-cta {
  padding: 1.5rem;
  border-width: 0px;
}

   .c-guide .c-mini-cta__content {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

   @media (max-width: 767px) { .c-guide .c-mini-cta__content {
    width: 100%;
    text-align: center;
    align-items: center;
  }
}

   .c-guide .c-mini-cta__content__text {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

   .c-guide .c-mini-cta__content .c-button {
  font-size: 1.125rem;
  line-height: 1.75rem;
        padding: 12px 14px;
}

   .c-guide .c-mini-cta__screenshot {
  width: 50%;
  margin-left: 2rem;
  display: flex;
  justify-content: flex-end;
}

   @media (max-width: 767px) { .c-guide .c-mini-cta__screenshot {
    width: 100%;
    justify-content: center;
    margin-bottom: 0.75rem;
    margin-left: 0px;
  }
}

   .c-guide .c-mini-cta__screenshot img {
        width: 250px;
      }

/*# sourceMappingURL=data:application/json;base64,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 */